import { FC, useEffect } from 'react';

import { useMedia } from '@pp/core/src/hooks/useMedia';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import { RecentResultDetail } from '../../../components/recentResultDetail/RecentResultDetail';
import { useChartsDataFetcher } from '../../../store/apiHooks/useChartsDataFetcher';
import { HeaderNavigationCarousel } from '../headerNavigator/HeaderNavigationCarousel';

import { StatsCharts } from './charts/StatsCharts';
import { StatsLastResults } from './lastResults/StatsLastResults';

import styles from './TableStatsConnected.module.css';

const componentMap: Record<string, JSX.Element> = {
  LAST_RESULTS: <StatsLastResults />,
  CHARTS: <StatsCharts />,
};

export const TableStatsConnected: FC = () => {
  const isWide = useMedia('(min-width: 1024px)');

  const chartsDataFetcher = useChartsDataFetcher();
  useEffect(() => {
    chartsDataFetcher();
  }, [chartsDataFetcher]);

  return (
    <div className={styles.tableStats_container}>
      {!isWide && <RecentResultDetail />}
      <HeaderNavigationCarousel
        tabs={Object.keys(componentMap).map((tab) => ({
          label: <L10nText tk={tab} />,
          content: componentMap[tab],
          key: tab,
        }))}
      />
    </div>
  );
};
